import React, { useEffect, useState } from "react"
import PhotoTile from "./PhotoTile"
import Lightbox from "./Lightbox/Lightbox"
import PhotoFilter from "../filtering/PhotoFilter"
import Loading from "../content/Loading"

const PhotoGallery = ({photos}) => {
    const [selectedPhoto, setSelectedPhoto] = useState()
    const [filteredPhotos, setFilteredPhotos] = useState(photos)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (photos.length === 0) {
            setIsLoading(false);
            return;
        }

        let loadedCount = 0;
        photos.forEach((photo) => {
            const img = new Image();
            img.src = photo.url;
            img.onload = () => {
                loadedCount++;
                if (loadedCount === photos.length) {
                    setIsLoading(false);
                }
            };
            img.onerror = () => {
                loadedCount++;
                if (loadedCount === photos.length) {
                    setIsLoading(false);
                }
            };
        });
    }, [photos]);

    const applyFilters = (filters)=> {
        const updatedPhotos = photos.filter((photo) => {
            return (filters["camera"].has(photo["camera"]) 
            && filters["colors"].has(photo["hueBucket"]) 
            && filters["aperture"].has(photo["apertureBucket"])
            && filters["shutterspeed"].has(photo["shutterspeedBucket"]))
        })
        setFilteredPhotos(updatedPhotos)
    }

    return (
        <div>
            {isLoading ? (
                <Loading/>
            ) : (
                <>
                    <div className="container photo-gallery-grid">
                        {filteredPhotos.length > 0 ? (
                            filteredPhotos.map((photo) => (
                                <PhotoTile
                                    key={photo.id}
                                    photo={photo}
                                    onClick={() => setSelectedPhoto(photo)}
                                />
                            ))
                        ) : (
                            "No photos with these properties."
                        )}
                        {selectedPhoto && (
                            <Lightbox
                                photo={selectedPhoto}
                                onClose={() => setSelectedPhoto(null)}
                            />
                        )}
                    </div>
                    <PhotoFilter applyFilters={applyFilters} />
                </>
            )}
        </div>
    )
}

export default PhotoGallery

// Lightweight photo gallery without filtering
export const PhotoGalleryLite = ({photos}) => {
    const [selectedPhoto, setSelectedPhoto] = useState()

    return (
        <div>
            <div className="container photo-gallery-grid">
                {photos.map((photo) => {
                    return (
                        <PhotoTile key={photo.id} photo={photo} onClick={() => setSelectedPhoto(photo)} />
                    )
                })}
                {selectedPhoto && <Lightbox photo={selectedPhoto} onClose={() => setSelectedPhoto(null)} />}
            </div>
        </div>
    )
}